import React, { FC, useState } from "react";
import {
    Button,
    FireworksBackground,
    GoogleBusinessProfile,
    OnboardingAside,
    OnboardingContent,
} from "@xapp/components";

import { OnboardingProps } from "../../models";

import classes from "./CustomizeStep.module.scss";

export interface CustomizeStepProps {
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;

    aside?: React.ReactNode;

    onboarding: OnboardingProps;

    onCustomize(props: OnboardingProps): void;
}

// TODO: Rename?  This is actually the, you are eligible for book online step
export const CustomizeStep: FC<CustomizeStepProps> = (props) => {
    const { aside, onboarding } = props;

    const [showBookOnline, setShowBookOnline] = useState(false);

    const handleNext = () => {
        props.onCustomize(onboarding);
    };

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent>
                <FireworksBackground style={{ height: "100%" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
                        <GoogleBusinessProfile
                            place={onboarding.place}
                            showBookOnline={showBookOnline}
                            styles={{ razzleDazzle: true }}
                        />
                        {!showBookOnline && (
                            <Button
                                id={"previewBookOnline"}
                                variation="secondary"
                                label="Preview Book Online Button"
                                style={{ marginTop: "10px", border: "none", textDecoration: "underline" }}
                                onClick={() => setShowBookOnline(!showBookOnline)}
                            />
                        )}
                        <Button
                            style={{
                                width: "100%",
                                height: "60px",
                                maxWidth: "350px",
                                marginTop: "30px",
                                // backgroundColor: "#39d75a",
                            }}
                            id="addBookOnlineButton"
                            variation="primary"
                            label="Add Book Online Button to Profile"
                            onClick={handleNext}
                        />

                        <div className={classes.showMobile} style={{ padding: "30px" }}>
                            {aside}
                        </div>
                    </div>
                </FireworksBackground>
            </OnboardingContent>
        </>
    );
};
